//
//
//
//
//
//
//
//
//
//
//
//
//

import { faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ShareButtons',
  props: {
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    fullUrl () {
      const lang = this.$store.getters['util/getCurrentLanguage']
      return process.client ? `${window.location.protocol}//${window.location.host}/${lang.code}/${this.url}` : ''
    },
    facebookUrl () {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.fullUrl}`
    },
    linkedInUrl () {
      return `https://www.linkedin.com/shareArticle?mini=true&url=${this.fullUrl}`
    },
    facebookIcon () {
      return faFacebookF
    },
    linkedinIcon () {
      return faLinkedinIn
    }
  }
}
